import { Navigate } from 'react-router-dom';

import useUserState from '@/hook/useUserState';
import { 월별_결제_내역_다운로드_라우터 } from '@/router/cafe24-master-account';
import { roleCafe24Master, roleOwner } from '@/router/consts';
import { sellerMap } from '@/router/managementMaps';
import { 매니저_라우터 } from '@/router/manager';

/**
 * root 진입시 redirect
 */
export default function RedirectHandler() {
  const user = useUserState();

  switch (user?.roles[0]) {
    case undefined:
      return <Navigate to={'/login'} replace={true} />;
    case roleCafe24Master:
      return <Navigate to={월별_결제_내역_다운로드_라우터['cafe24'].path} replace={true} />;
    case roleOwner:
      return <Navigate to={sellerMap['dashboard'].path} replace={true} />;
    default:
      return <Navigate to={매니저_라우터['shop-list'].path} replace={true} />;
  }
}
